import { css } from '@emotion/react';
import { ReactNode } from 'react';

export const FormLine = ({
	children,
	first,
	noPaddingBottom,
}: {
	children: ReactNode;
	first?: boolean;
	noPaddingBottom?: boolean;
}) => {
	return (
		<div
			css={css`
				border-bottom: 1px solid #f1f1f4;
				padding: 12px 0;
				display: flex;
				min-height: 44px;
				display: flex;
				align-items: center;

				flex-wrap: wrap;

				${first &&
				css`
					padding-top: 0;
				`}

				${noPaddingBottom &&
				css`
					padding-bottom: 0;
				`}
			`}
		>
			{children}
		</div>
	);
};
